import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import ResellerOrganizationsTable from '~/vue_widgets/reseller/organizations_table.vue'

export default class extends Controller {
  static values = {
    accountId: String,
    resellerIdentifier: String
  }

  connect() {
    this.vue = createApp(ResellerOrganizationsTable, {
      accountId: this.accountIdValue,
      resellerIdentifier: this.resellerIdentifierValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
